import { CardioOrResistance } from 'fitbeat.models';
import { burnBodyImages, buildBodyImages, bodyImageGreyScale,
   smallDetailedBurnBodyImages, smallDetailedBuildBodyImages , bodyImage } from './BodyImageSets';
import Theme from '../theme';

const getImageFromImageSet = (threeBodyGroups = [], gender = 'female', imageSet) => {
  if (gender === 'other') {
    gender = 'female';
  }

  const sortedThreeBodyGroups = [...threeBodyGroups].sort().join(' ');
  const bodyKey = `${gender} - ${sortedThreeBodyGroups}`;

  let bodyGroupImage = imageSet[bodyKey];

  if (bodyGroupImage) {
    return bodyGroupImage;
  }

  return buildBodyImages[`${gender} - `];
};

export const getBodyGroupImage = (threeBodyGroups = [], cardioOrResistance, gender = 'female') => {
  if (cardioOrResistance === CardioOrResistance.Cardio) {
    return getImageFromImageSet(threeBodyGroups, gender, burnBodyImages);
  }
  return getImageFromImageSet(threeBodyGroups, gender, buildBodyImages);
};

export const getGreyScaleBodyGroupImage = (threeBodyGroups = [], gender = 'female') => {
  return getImageFromImageSet(threeBodyGroups, gender, bodyImageGreyScale);
};

export const getSmallDetailedBodyGroupImage = (threeBodyGroups = [], gender = 'female', cardioOrResistance= CardioOrResistance.Cardio) => {
  if (cardioOrResistance === CardioOrResistance.Cardio) {
    return getImageFromImageSet(threeBodyGroups, gender, smallDetailedBurnBodyImages);
  }
  return getImageFromImageSet(threeBodyGroups, gender, smallDetailedBuildBodyImages);
};

export const getBodySvgKey = (threeBodyGroups = [], gender = 'female') => {
  if (gender === 'other') {
    gender = 'female';
  }
  const sortedThreeBodyGroups = [...threeBodyGroups].sort().join(' ');
  const bodySvgKey = `${gender} - ${sortedThreeBodyGroups}`;
  return bodySvgKey;
};

export const getBodyImage = (threeBodyGroups = [], gender = 'female', cardioOrResistance = CardioOrResistance.Cardio,
                             width = '100%', height = '100%', fill1 = Theme.WHITE, fill2 = Theme.GREY) => {
  const nonTargetedMusclesGroupColor = cardioOrResistance === CardioOrResistance.Cardio ? Theme.PRIMARY_LIGHT : Theme.GREY;
  const svgKey = getBodySvgKey( threeBodyGroups, gender);
  return bodyImage(fill1, fill2, nonTargetedMusclesGroupColor, width, height, svgKey);
};
